<template>
  <layout-report-step :isDone="isDone" :title="header.title" :description="header.description" :image="header.image">
    <v-card flat max-width="500" class="pt-4">
      <report-image-upload
        :asset="asset"
        :example="example"
        :instruction="instruction"
        :type="type"
        textAlt="report.imageWheel.altText"
      />
    </v-card>
  </layout-report-step>
</template>

<script lang="ts">
import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { AssetEnum } from "@/lib/AssetRepository";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportInstructionData } from "@/lib/interfaces/Report/IReportInstructionData";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import ReportStepMixin from "@/mixins/ReportStepMixin.vue";
import { IImageUploaded } from "@/models/Image/IImageUploaded";
import { ReportImageType } from "@/models/Report/ReportImageType";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { ReportModule } from "@/store/modules/report.store";
import { Component } from "vue-property-decorator";
import ReportImageUpload from "./ReportImageUpload.vue";

@Component({
  components: {
    LayoutReportStep,
    ReportImageUpload
  }
})
export default class ReportImageWheel extends ReportStepMixin implements IReportStep {
  asset = AssetEnum.wheelExampleOutlined;
  example = AssetEnum.wheelExample;

  screen = ReportScreenEnum.wheelImage;

  header: IReportHeaderData = {
    title: "report.imageWheel.title",
    description: "report.imageWheel.description",
    debug: this.files,
    image: AssetEnum.wheelExample
  };

  instruction: IReportInstructionData = {
    title: "",
    text: "",
    pictures: [AssetEnum.wheelExample],
    example: AssetEnum.wheelExample,
    display: false
  };

  get isDone() {
    return this.files.length > 0;
  }

  get type() {
    return ReportImageType.wheel;
  }

  get files(): IImageUploaded[] {
    return ReportModule.overviews.filter((image) => image.type === this.type);
  }
}
</script>
